<template>
  <div class="vehicle_info" v-if="visible" style="width: 100%">
    <div style="text-align: center">
      <kl-label :title="title" bold :fontSize="14" />
    </div>
    <el-divider></el-divider>
    <!-- <kl-label :title="$t('locateVehicle.vehicle_monitoring_info')" bold /> -->
    <el-row>
      <el-col :span="12" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.acc_state') + ':'"
          bold
          type="success"
          :value="acc"
          icon="icon-icon_jiankongdanchuang_ACC"
      /></el-col>
      <el-col :span="12" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.speed') + '(km/h):'"
          bold
          type="danger"
          :value="speed"
          icon="icon-icon_jiankongdanchuang_chesu"
      /></el-col>
      <el-col :span="12" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.engineRev') + '(rpm):'"
          bold
          type="danger"
          :value="engineRev"
          icon="icon-icon_jiankongdanchuang_zhuansu"
      /></el-col>
      <el-col :span="12" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.direction') + ':'"
          bold
          :value="direction"
          icon="icon-icon_jiankongdanchuang_fangxiang"
      /></el-col>
      <el-col :span="12" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.totalMileage') + '(km):'"
          type="danger"
          bold
          :value="mileage"
          icon="icon-icon_jiankongdanchuang_yunhanglicheng"
      /></el-col>

      <el-col v-if="soc" :span="12" style="margin-top: 12px">
        <kl-info
          title="SOC："
          type="success"
          bold
          :value="soc"
          icon="icon-icon_battery"
      /></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.upTime') + ':'"
          bold
          :value="gpsDateTime"
          icon="icon-icon_inputbox_time"
        />
      </el-col>
    </el-row>
    <el-row v-if="position">
      <el-col :span="24" style="margin-top: 12px">
        <kl-info
          :title="$t('locateVehicle.position') + ':'"
          bold
          :value="position"
          icon="icon-icon_jiankongdanchuang_weizhi"
        />
      </el-col>
    </el-row>
    <kl-label v-if="false" :title="$t('locateVehicle.车辆基础信息')" style="margin-top: 30px" bold />
    <el-row v-if="false">
      <el-col
        :span="12"
        v-for="(item, index) in base_items"
        :key="index"
        style="margin-top: 12px"
      >
        <kl-info
          :title="item.title"
          :type="item.color"
          :value="item.value"
          :icon="item.icon"
      /></el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      position: "",
      acc: "", //acc状态
      speed: "", //车速
      engineRev: "", //转速
      direction: "", //方向
      mileage: "", //运行总里程
      title: "", //标题
      soc: undefined, //soc
      gpsDateTime: "", //上报时间
      base_items: [
        {
          icon: "",
          title: "VIN码：",
          value: "LA6R1HSK29B103025",
          color: "",
        },
        {
          icon: "",
          title: "车型：",
          value: "XMQ6121Y5",
          color: "",
        },
        {
          icon: "",
          title: "燃料类型：",
          value: "柴油机",
          color: "",
        },
        {
          icon: "",
          title: "驾驶员：",
          value: "",
          color: "",
        },
      ],
    };
  },
  methods: {
    show(
      CarNo,
      AccState,
      Speed,
      EngineRev,
      Direction,
      Mileage,
      Position,
      GpsTime,
      Soc
    ) {
      //acc状态
      this.acc = this.convertState(AccState);
      this.speed = parseFloat(Speed).toFixed(2) + " km/h";
      this.engineRev = EngineRev + " rpm";
      this.direction = this.convertDirection(Direction); //
      //里程
      this.mileage = parseFloat(Mileage).toFixed(2) + " km";
      //SOC 从新能源缓存的接口获取
      this.position = Position;

      this.gpsDateTime = GpsTime;
      this.soc = Soc;
      this.title = CarNo;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    toggle() {
      this.visible = !this.visible;
    },
    convertState(state) {
      if (state == undefined) return this.$t("public.unKnown");
      var result;
      if ((state & 1) != 0) result = this.$t("locateVehicle.acc_open");
      else result = this.$t("locateVehicle.acc_close");
      //        if ((state & 2) != 0) result += ",定位"; else result += ",未定位";
      //        if ((state & 4) != 0) result += ",南纬"; else result += ",北纬";
      //        if ((state & 8) != 0) result += ",西经"; else result += ",东经";
      //        if ((state & 16) != 0) result += ",停运状态"; else result += ",运营状态";
      //        if ((state & 32) != 0) result += ",经纬度已经保密插件加密"; else result += ",经纬度未经保密插件加密";
      //        if ((state & 1024) != 0) result += ",油路断开"; //else result += ",油路正常";
      //        if ((state & 2048) != 0) result += ",电路断开"; //else result += ",电路正常";
      //        if ((state & 4096) != 0) result += ",车门加锁"; else result += ",车门解锁";
      return result;
    },
    convertDirection(direction) {
      try {
        if (direction == undefined) return this.$t("public.unKnown");
        else if (direction == 0.0 || direction == 360.0)
          return this.$t("direction.north");
        else if (direction > 0 && direction < 90)
          return (
            this.$t("direction.eastNorth") +
            (90.0 - direction) +
            this.$t("direction.degree")
          );
        else if (direction == 90) return AppResources.east;
        else if (direction > 90 && direction < 180)
          return (
            this.$t("direction.eastSouth") +
            (direction - 90) +
            this.$t("direction.degree")
          );
        else if (direction == 180) return this.$t("direction.south");
        else if (direction > 180 && direction < 270)
          return (
            this.$t("direction.westSouth") +
            (270.0 - direction) +
            this.$t("direction.degree")
          );
        else if (direction == 270) return AppResources.west;
        else if (direction > 270 && direction < 360)
          return (
            this.$t("direction.westNorth") +
            (direction - 270.0) +
            this.$t("direction.degree")
          );
        else return this.$t("public.unKnown");
      } catch (e) {
        return this.$t("public.unKnown");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
 ::v-deep .el-dialog__body {
  padding: 0 !important;
}

.vehicle_info {
  padding: 0 20px 20px 20px;
  text-align: left;
}
</style>
